import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { OAuthService } from "angular-oauth2-oidc";

@Injectable({
	providedIn: "root",
})
export class AuthGuard implements CanActivate {
	constructor(private oauthService: OAuthService, private router: Router) {}

	canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		if (!this.oauthService.hasValidAccessToken()) {
			localStorage.setItem("intendedUrl", state.url);
			this.oauthService.initCodeFlow();
			return false;
		}
		return true;
	}
}
